import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CAFCASS_CUSTOM_ROUTE_CONFIG } from './custom-route-config';
import { CustomTodayModule } from './custom-today/custom-today.component';
import { MyBoardModule } from '@app/views/my-board/my-board.component';
import { CustomFindInformationModule } from './views/custom-find-information/custom-find-information.component';

@NgModule({
  imports: [
    CustomTodayModule,
    MyBoardModule,
    CustomFindInformationModule,
    RouterModule.forRoot(CAFCASS_CUSTOM_ROUTE_CONFIG, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
})
  ]
})
export class CafcassAppRoutingModule { }
